import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../services/authentication/login.service';

@Component({
  selector: 'app-logidriver',
  templateUrl: './logidriver.component.html',
  styleUrls: ['./logidriver.component.css']
})
export class LogidriverComponent implements OnInit {

  	menu:any;
  	permissions = [];

	constructor(public auth: LoginService) { }

	ngOnInit() {
		this.menu = [
			{name:'Mis Rutas', desc:'Rutas', icon:'fas fa-route', url:'/myrouteslogistics', perm: 'LOGI-DRIVER-ROUTES'},
			{name:'Mi Perfil', desc:'Profile', icon:'fas fa-user', url:'/driverprofilelogistics', perm: 'LOGI-DRIVER-PROFILE'}
		];

		this.auth.getPermissions().then(x => {
            this.permissions = x;
        });
	}

	hasPermission(str:string){
        if( this.permissions.indexOf(str) > -1 ){
            return true;
        }
        else{
            return false;
        }
    }

}
